module.exports = __webpack_public_path__ + "img/footer-bg.b5326cbe.jpg";